import React from 'react'
import styles from './CompetencyCard.module.scss'
import { TraitsMatch } from 'components/common/TraitsMatch/TraitsMatch'
import cx from 'classnames'
import { DonutChart } from 'components/common/DonutChart/DonutChart'

export const CompetencyCard = ({
  trait,
  isGreen,
  traitScores,
  explanation,
  scoreLabel,
  isSingle,
  language,
  onTab,
  isJobSeeker,
}) => {
  return (
    <div
      className={cx(styles.competencyCard, {
        [styles.singleCard]: isSingle,
      })}
    >
      <div className={styles.visualisations}>
        <div className={styles.title}>{trait.label}</div>
        <DonutChart
          scoreLabel={scoreLabel}
          isGreen={isGreen}
          value={trait.score * 25}
        />
        <TraitsMatch
          trim={!isSingle}
          isGreen={isGreen}
          data={traitScores}
          language={language}
          single
          onTab={onTab}
          isJobSeeker={isJobSeeker}
        />
      </div>
      <div className={styles.description}>
        <div
          className={cx(styles.score, {
            [styles.isGreen]: isGreen,
          })}
        >{`Score: ${trait.score}/4`}</div>
        <div className={styles.paragraph}>
          <div>
            <div>{explanation[0]}</div>
            <br />
            <div>{explanation[1]}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
